import { useParams } from 'next/navigation';

const useRouteId = () => {
  const params = useParams();
  return params?.id as string;
};

export default useRouteId;
